<template>
  <div class="matching_box">
    <TableBox :is-with-header="false" :table-contents="generateMatchingData"/>
    <router-link :to="{name: 'Meeting', params: {matchingId: matching.id}}" class="blue-ellipse_button">
      詳細を見る
    </router-link>
  </div>
</template>

<script>
  import moment from "moment";
  import TableBox from "@/components/molecules/box/TableBox";

  export default {
    name: "MatchingBox",

    components: {TableBox},

    props: {
      matching: {
        type: Object,
        required: true
      }
    },

    computed: {
      generateMatchingData() {
        return {
          deadline: {
            dt: 'マッチング日時',
            dd: !this.matching.createdAt ? '' : moment.unix(this.matching.createdAt.seconds).format('YYYY/MM/DD HH:mm'),
          },
        }
      }
    },
  }
</script>


<style lang="scss" scoped>
  .matching_box {
    display: flex;
    flex-flow: column;
    align-items: flex-end;

    > .table_box {
      margin: 2rem 0;
      width: 100%;
    }
    > .blue-ellipse_button {
      margin-bottom: 4rem;
    }
  }

</style>